module.exports = __webpack_public_path__ + "img/122.did_not_find.bd2f9c44.svg";